import { WorkflowListProps } from "interfaces/workflows/WorkflowListProps";
import { WorkflowDto } from "models/workflows/WorkflowDto";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiService } from "services/ApiService";

export const WorkflowsList: React.FC<WorkflowListProps> = ({ ownerId, onCreateNew, onSelect }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [workflowList, setWorkflowList] = useState<WorkflowDto[]>([]);
    const { teamId } = useParams<{ teamId: string; }>();

    useEffect(() => {
        const fetchWorkflows = async () => {
            if (!teamId) return;
            
            try {
                const response = await ApiService.getWorkflows(teamId);

                if (response.success && response.data) {
                    setWorkflowList(response.data);
                }
            } catch (error) {
                console.error("Error fetching workflows:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchWorkflows();
    }, [teamId]);

    
    const handleDeleteWorkflow = async (workflowId: string) => {
        if (!teamId) return;
        
        try {
            const response = await ApiService.deleteWorkflow(teamId, workflowId);
            console.log("response is " + response);
            if (response.success) {
                setWorkflowList((workflows) => {
                    return workflows.filter((c) => c.id !== workflowId);
                });
            }
        } catch {
            console.log("deleting here is failing");
        }
    };

    if (!teamId) return null;


    if (isLoading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Workflows</h2>
            {workflowList.length > 0 ? (
                <ul className="divide-y divide-gray-300">
                    {workflowList.map((workflow) => (
                        <li
                            key={workflow.id}
                            onClick={() => onSelect(workflow.id)}
                            className="cursor-pointer p-4 hover:bg-gray-100 flex justify-between items-center border border-gray-200 rounded"
                        >
                            <span>{workflow.name.length > 0 ? workflow.name : workflow.id}</span>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteWorkflow(workflow.id);
                                }}
                                className="inline-flex items-center justify-center rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                            >
                                Delete
                            </button>
                        </li>

                    ))}
                </ul>
            ) : (
                <p className="text-gray-600">No workflows found :/</p>
            )}
            <button
                onClick={onCreateNew}
                className="mt-4 inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Create New Workflow
            </button>
        </div>
    );
};